import { Component, inject, OnInit } from '@angular/core';

import { DialogRef } from '@ngneat/dialog';
import { SurveyAnswerDetailsEntity, SurveyEntity } from '@core/entities';
import { TranslateModule } from '@ngx-translate/core';
import { isMobileView } from '@core/utils';
import { NgxBottomSheetService } from 'ngx-bottom-sheet';

@Component({
  selector: 'app-survey-voter-details',
  imports: [TranslateModule],
  templateUrl: './survey-voter-details.component.html',
  styleUrls: ['./survey-voter-details.component.scss'],
})
export class SurveyVoterDetailsComponent implements OnInit {
  surveyResults: SurveyAnswerDetailsEntity;
  currentSurvey: SurveyEntity;
  private readonly _dialogRef: DialogRef;
  private readonly _bottomSheet: NgxBottomSheetService;

  constructor() {
    if (isMobileView()) {
      this._bottomSheet = inject(NgxBottomSheetService);
    } else {
      this._dialogRef = inject(DialogRef);
    }
  }

  ngOnInit(): void {
    if (isMobileView()) {
      this.surveyResults = this._bottomSheet.currentSheetData.surveyResult;
      this.currentSurvey = this._bottomSheet.currentSheetData.currentSurvey;
    } else {
      this.surveyResults = this._dialogRef.data.surveyResult;
      this.currentSurvey = this._dialogRef.data.currentSurvey;
    }
  }
}
